/** ISO dates and 24-hour times work with the parser in every site locale. */
const SCHEDULES = {
  coffee: ['01-14, 09:00', '01-14, 12:30'],
  design: ['02-10, 10:00', '02-12, 15:00'],
  books: ['03-05, 18:30', '03-19, 19:00'],
  exercise: ['04-07, 07:30', '04-09, 18:00'],
  art: ['05-16, 14:00', '05-23, 11:00'],
  garden: ['06-13, 12:00', '06-20, 16:00'],
  culture: ['07-08, 10:30', '07-09, 20:00'],
  travel: ['08-21, 08:15', '08-21, 19:30'],
  music: ['09-12, 17:00', '09-19, 18:30'],
  community: ['10-03, 09:00', '10-10, 10:00'],
  cooking: ['11-06, 18:00', '11-13, 19:00'],
  winter: ['12-05, 11:00', '12-20, 17:30'],
} as const;

/** Every catalogue supplies both titles for all twelve examples. */
export type ExampleTitles = {
  readonly [Key in keyof typeof SCHEDULES]: readonly [string, string];
};

export function funnelExamples(year: number, titles: ExampleTitles): readonly string[] {
  return (Object.keys(SCHEDULES) as (keyof ExampleTitles)[]).map((key) =>
    SCHEDULES[key].map((date, index) => `${titles[key][index]}, ${year}-${date}`).join('\n'),
  );
}
